module.exports = __webpack_public_path__ + "static/mesa-6e8cc8f4a25dfe40e81ab5e627667e76.png";